<template>
    <header class="landing-header" :class="{ 'mobile-context-header': mobileHeaderMode !== 'default' && isMobileViewport }">
      <template v-if="mobileHeaderMode === 'search-details' && isMobileViewport">
        <div class="mobile-switcher">
          <button
            type="button"
            class="mobile-back-button"
            aria-label="Go back"
            @click="navigateBack"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" class="back-icon">
              <path
                d="M15.5 4.5L8 12l7.5 7.5"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2.4"
              />
            </svg>
          </button>
          <button
            type="button"
            class="switch-button"
            :class="{ 'switch-button-active': currentMobileSection === 'search' }"
            @click="goToSearch"
          >
            Search
          </button>
          <button
            type="button"
            class="switch-button"
            :class="{ 'switch-button-active': currentMobileSection === 'details' }"
            :disabled="!currentGameId"
            @click="goToDetails"
          >
            Details
          </button>
        </div>
      </template>

      <template v-else-if="mobileHeaderMode === 'back-only' && isMobileViewport">
        <button
          type="button"
          class="mobile-back-button"
          aria-label="Go back"
          @click="navigateBack"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" class="back-icon">
            <path
              d="M15.5 4.5L8 12l7.5 7.5"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2.4"
            />
          </svg>
        </button>
      </template>

      <template v-else>
        <div
          class="logo"
          :class="{ 'is-disabled': logoDisabled }"
          @click="handleHomeClick"
        >
          <img src="@/assets/balleralgo_small_logo.png" alt="BallerAlgo Logo" />
        </div>
        <div class="navigation">
          <router-link
            to="/football"
            class="nav-link"
            :class="{ 'is-disabled': navDisabled }"
            @click.prevent="handleFootballClick"
          >
            Football
          </router-link>
        </div>
      </template>
    </header>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    interactive: {
      type: Boolean,
      default: true,
    },
    disableOnMobile: {
      type: Boolean,
      default: false,
    },
    mobileHeaderMode: {
      type: String,
      default: "default",
    },
    baseRoute: {
      type: String,
      default: "/football",
    },
    currentGameId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      isMobileViewport: false,
    };
  },
  computed: {
    interactionsDisabled() {
      return !this.interactive || (this.disableOnMobile && this.isMobileViewport);
    },
    logoDisabled() {
      return this.interactionsDisabled;
    },
    navDisabled() {
      return this.interactionsDisabled;
    },
    currentMobileSection() {
      return this.currentGameId ? "details" : "search";
    },
  },
  mounted() {
    this.updateViewportMode();
    window.addEventListener('resize', this.updateViewportMode);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateViewportMode);
  },
  methods: {
    updateViewportMode() {
      this.isMobileViewport = window.innerWidth <= 900;
    },
    handleHomeClick() {
      if (this.logoDisabled) {
        return;
      }
      this.navigateHome();
    },
    handleFootballClick() {
      if (this.navDisabled) {
        return;
      }
      this.$router.push('/football');
    },
    navigateHome() {
      this.$router.push('/');
    },
    goToSearch() {
      this.$router.push(this.baseRoute);
    },
    goToDetails() {
      if (!this.currentGameId) {
        return;
      }
      this.$router.push(`${this.baseRoute}/${this.currentGameId}`);
    },
    navigateBack() {
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }
      this.$router.push('/');
    }
  }
};
</script>


<style scoped>
.landing-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5vh;
}

.mobile-context-header {
  margin-bottom: 0;
  padding: 12px;
  border-bottom: 1px solid #e9eef3;
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 6;
}

.logo img {
  max-width: 30px;
  cursor: pointer;
}

.logo.is-disabled img {
  cursor: default;
}

.navigation {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.nav-link {
  margin-right: 20px;
  text-decoration: none;
  color: #333;
}

.nav-link.is-disabled {
  pointer-events: none;
  cursor: default;
}

.logo.is-disabled,
.nav-link.is-disabled {
  visibility: hidden;
}

.mobile-switcher {
  display: flex;
  width: 100%;
  gap: 10px;
}

.switch-button,
.mobile-back-button {
  appearance: none;
  border: 1px solid #d6e0ea;
  border-radius: 999px;
  background: #f6f9fc;
  color: #173252;
  font-size: 0.9rem;
  font-weight: 700;
  padding: 10px 16px;
}

.switch-button {
  flex: 1;
}

.switch-button-active {
  background: #173252;
  border-color: #173252;
  color: #ffffff;
}

.switch-button:disabled {
  opacity: 0.45;
}

.mobile-back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  padding: 10px;
}

.back-icon {
  width: 16px;
  height: 16px;
}

@media (min-width: 901px) {
  .mobile-context-header {
    position: static;
    padding: 0;
    border-bottom: none;
    background: transparent;
  }
}
</style>
